const templateWizardFormFields = {
  blockFields: [
    {
      label: 'Inherit Website CSS',
      controlId: 'all',
      name: 'all',
      inputType: 'select',
      options: [
        { value: 'initial', label: 'No' },
        { value: 'inherit', label: 'Yes' },
      ],
      stateKey: 'all',
    },
    {
      label: 'Fluid Container',
      controlId: 'fluidContainer',
      name: 'fluidContainer',
      inputType: 'select',
      options: [
        { value: 'false', label: 'No' },
        { value: 'true', label: 'Yes' },
      ],
      stateKey: 'fluidContainer',
    },
    {
      label: 'Width',
      controlId: 'width',
      name: 'width',
      inputType: 'number',
      stateKey: 'width',
    },
    {
      label: 'Background Color',
      controlId: 'background-color',
      name: 'background-color',
      inputType: 'color',
      stateKey: 'background-color',
    },
    {
      label: 'Padding Top',
      controlId: 'padding-top',
      name: 'padding-top',
      inputType: 'number',
      stateKey: 'padding-top',
    },
    {
      label: 'Padding Left',
      controlId: 'padding-left',
      name: 'padding-left',
      inputType: 'number',
      stateKey: 'padding-left',
    },
    {
      label: 'Padding Right',
      controlId: 'padding-right',
      name: 'padding-right',
      inputType: 'number',
      stateKey: 'padding-right',
    },
    {
      label: 'Padding Bottom',
      controlId: 'padding-bottom',
      name: 'padding-bottom',
      inputType: 'number',
      stateKey: 'padding-bottom',
    },
    {
      label: 'Margin Top',
      controlId: 'margin-top',
      name: 'margin-top',
      inputType: 'number',
      stateKey: 'margin-top',
    },
    {
      label: 'Margin Left',
      controlId: 'margin-left',
      name: 'margin-left',
      inputType: 'number',
      stateKey: 'margin-left',
    },
    {
      label: 'Margin Right',
      controlId: 'margin-right',
      name: 'margin-right',
      inputType: 'number',
      stateKey: 'margin-right',
    },
    {
      label: 'Margin Bottom',
      controlId: 'margin-bottom',
      name: 'margin-bottom',
      inputType: 'number',
      stateKey: 'margin-bottom',
    },
  ],
  arrowsFields: [
    {
      label: 'Auto Center',
      controlId: 'centered',
      name: 'centered',
      inputType: 'select',
      options: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' },
      ],
      stateKey: 'centered',
    },
    {
      label: 'Left',
      controlId: 'left',
      name: 'left',
      inputType: 'number',
      stateKey: 'left',
    },
    {
      label: 'Top',
      controlId: 'top',
      name: 'top',
      inputType: 'number',
      stateKey: 'top',
    },
    {
      label: 'Right',
      controlId: 'right',
      name: 'right',
      inputType: 'number',
      stateKey: 'right',
    },
    {
      label: 'Padding Top',
      controlId: 'padding-top',
      name: 'padding-top',
      inputType: 'number',
      stateKey: 'padding-top',
    },
    {
      label: 'Padding Left',
      controlId: 'padding-left',
      name: 'padding-left',
      inputType: 'number',
      stateKey: 'padding-left',
    },
    {
      label: 'Padding Right',
      controlId: 'padding-right',
      name: 'padding-right',
      inputType: 'number',
      stateKey: 'padding-right',
    },
    {
      label: 'Padding Bottom',
      controlId: 'padding-bottom',
      name: 'padding-bottom',
      inputType: 'number',
      stateKey: 'padding-bottom',
    },
    {
      label: 'Background Color',
      controlId: 'background-color',
      name: 'background-color',
      inputType: 'color',
      stateKey: 'background-color',
    },
    {
      label: 'Border',
      controlId: 'border',
      name: 'border',
      inputType: 'text',
      stateKey: 'border',
    },
    {
      label: 'Border Radius',
      controlId: 'border-radius',
      name: 'border-radius',
      inputType: 'number',
      stateKey: 'border-radius',
    },
    {
      label: 'Fill',
      controlId: 'fill',
      name: 'fill',
      inputType: 'color',
      stateKey: 'fill',
    },
    {
      label: 'Stroke',
      controlId: 'stroke',
      name: 'stroke',
      inputType: 'color',
      stateKey: 'stroke',
    },
  ],
  discountBadgFields: [
    {
      label: 'Show',
      controlId: 'display',
      name: 'display',
      inputType: 'select',
      options: [
        { value: 'block', label: 'Yes' },
        { value: 'none', label: 'No' },
      ],
      stateKey: 'display',
    },
    {
      label: 'Font Style',
      controlId: 'font-style',
      name: 'font-style',
      inputType: 'select',
      options: [
        { value: 'normal', label: 'Normal' },
        { value: 'italic', label: 'Italic' },
        { value: 'oblique', label: 'Oblique' },
      ],
      stateKey: 'font-style',
    },
    {
      label: 'Font Weight',
      controlId: 'font-weight',
      name: 'font-weight',
      inputType: 'select',
      options: [
        { value: 'bold', label: 'Bold' },
        { value: '600', label: 'Semi-bold' },
        { value: '400', label: 'Normal' },
      ],
      stateKey: 'font-weight',
    },
    {
      label: 'Text Color',
      controlId: 'color',
      name: 'color',
      inputType: 'color',
      stateKey: 'color',
    },
    {
      label: 'Background Color',
      controlId: 'background-color',
      name: 'background-color',
      inputType: 'color',
      stateKey: 'background-color',
    },
    {
      label: 'Font Size',
      controlId: 'font-size',
      name: 'font-size',
      inputType: 'number',
      stateKey: 'font-size',
    },
    {
      label: 'Padding Top',
      controlId: 'padding-top',
      name: 'padding-top',
      inputType: 'number',
      stateKey: 'padding-top',
    },
    {
      label: 'Padding Left',
      controlId: 'padding-left',
      name: 'padding-left',
      inputType: 'number',
      stateKey: 'padding-left',
    },
    {
      label: 'Padding Right',
      controlId: 'padding-right',
      name: 'padding-right',
      inputType: 'number',
      stateKey: 'padding-right',
    },
    {
      label: 'Padding Bottom',
      controlId: 'padding-bottom',
      name: 'padding-bottom',
      inputType: 'number',
      stateKey: 'padding-bottom',
    },
    {
      label: 'Margin Top',
      controlId: 'margin-top',
      name: 'margin-top',
      inputType: 'number',
      stateKey: 'margin-top',
    },
    {
      label: 'Margin Left',
      controlId: 'margin-left',
      name: 'margin-left',
      inputType: 'number',
      stateKey: 'margin-left',
    },
    {
      label: 'Margin Right',
      controlId: 'margin-right',
      name: 'margin-right',
      inputType: 'number',
      stateKey: 'margin-right',
    },
    {
      label: 'Margin Bottom',
      controlId: 'margin-bottom',
      name: 'margin-bottom',
      inputType: 'number',
      stateKey: 'margin-bottom',
    },
    {
      label: 'Top',
      controlId: 'top',
      name: 'top',
      inputType: 'number',
      stateKey: 'top',
    },
    {
      label: 'Left',
      controlId: 'left',
      name: 'left',
      inputType: 'number',
      stateKey: 'left',
    },
    {
      label: 'Right',
      controlId: 'right',
      name: 'right',
      inputType: 'number',
      stateKey: 'right',
    },
    {
      label: 'Bottom',
      controlId: 'bottom',
      name: 'bottom',
      inputType: 'number',
      stateKey: 'bottom',
    },
  ],
  productNameFields: [
    {
      label: 'Text Align',
      controlId: 'text-align',
      name: 'text-align',
      inputType: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
      stateKey: 'text-align',
    },
    {
      label: 'Color',
      controlId: 'color',
      name: 'color',
      inputType: 'color',
      stateKey: 'color',
    },
    {
      label: 'Font Size',
      controlId: 'font-size',
      name: 'font-size',
      inputType: 'number',
      stateKey: 'font-size',
    },
    {
      label: 'Font Style',
      controlId: 'font-style',
      name: 'font-style',
      inputType: 'select',
      options: [
        { value: 'normal', label: 'Normal' },
        { value: 'italic', label: 'Italic' },
        { value: 'oblique', label: 'Oblique' },
      ],
      stateKey: 'font-style',
    },
    {
      label: 'Text Transform',
      controlId: 'text-transform',
      name: 'text-transform',
      inputType: 'select',
      options: [
        { value: 'capitalize', label: 'Capitalize' },
        { value: 'uppercase', label: 'Uppercase' },
        { value: 'lowercase', label: 'Lowercase' },
        { value: 'none', label: 'None' },
      ],
      stateKey: 'text-transform',
    },
    {
      label: 'Font Weight',
      controlId: 'font-weight',
      name: 'font-weight',
      inputType: 'select',
      options: [
        { value: '400', label: 'Normal' },
        { value: '600', label: 'Semi-bold' },
        { value: 'bold', label: 'Bold' },
      ],
      stateKey: 'font-weight',
    },
    {
      label: 'Text Decoration',
      controlId: 'text-decoration',
      name: 'text-decoration',
      inputType: 'select',
      options: [
        { value: 'none', label: 'None' },
        { value: 'underline', label: 'Underline' },
        { value: 'line-through', label: 'Line Through' },
        { value: 'overline', label: 'Overline' },
      ],
      stateKey: 'text-decoration',
    },
    {
      label: 'Padding Top',
      controlId: 'padding-top',
      name: 'padding-top',
      inputType: 'number',
      stateKey: 'padding-top',
    },
    {
      label: 'Padding Left',
      controlId: 'padding-left',
      name: 'padding-left',
      inputType: 'number',
      stateKey: 'padding-left',
    },
    {
      label: 'Padding Right',
      controlId: 'padding-right',
      name: 'padding-right',
      inputType: 'number',
      stateKey: 'padding-right',
    },
    {
      label: 'Padding Bottom',
      controlId: 'padding-bottom',
      name: 'padding-bottom',
      inputType: 'number',
      stateKey: 'padding-bottom',
    },
    {
      label: 'Margin Top',
      controlId: 'margin-top',
      name: 'margin-top',
      inputType: 'number',
      stateKey: 'margin-top',
    },
    {
      label: 'Margin Left',
      controlId: 'margin-left',
      name: 'margin-left',
      inputType: 'number',
      stateKey: 'margin-left',
    },
    {
      label: 'Margin Right',
      controlId: 'margin-right',
      name: 'margin-right',
      inputType: 'number',
      stateKey: 'margin-right',
    },
    {
      label: 'Margin Bottom',
      controlId: 'margin-bottom',
      name: 'margin-bottom',
      inputType: 'number',
      stateKey: 'margin-bottom',
    },
  ],
  productPriceFields: [
    {
      label: 'Font Style',
      controlId: 'font-style',
      name: 'font-style',
      inputType: 'select',
      options: [
        { value: 'normal', label: 'Normal' },
        { value: 'italic', label: 'Italic' },
        { value: 'oblique', label: 'Oblique' },
      ],
      stateKey: 'font-style',
    },
    {
      label: 'Font Weight',
      controlId: 'font-weight',
      name: 'font-weight',
      inputType: 'select',
      options: [
        { value: '400', label: 'Normal' },
        { value: '600', label: 'Semi-bold' },
        { value: 'bold', label: 'Bold' },
      ],
      stateKey: 'font-weight',
    },
    {
      label: 'Text Decoration',
      controlId: 'text-decoration',
      name: 'text-decoration',
      inputType: 'select',
      options: [
        { value: 'none', label: 'None' },
        { value: 'underline', label: 'Underline' },
        { value: 'line-through', label: 'Line Through' },
        { value: 'overline', label: 'Overline' },
      ],
      stateKey: 'text-decoration',
    },
    {
      label: 'Color',
      controlId: 'color',
      name: 'color',
      inputType: 'color',
      stateKey: 'color',
    },
    {
      label: 'Font Size (px)',
      controlId: 'font-size',
      name: 'font-size',
      inputType: 'number',
      stateKey: 'font-size',
    },
  ],
  titleFields: [
    {
      label: 'Background Color',
      controlId: 'background-color',
      name: 'background-color',
      inputType: 'color',
      stateKey: 'background-color',
    },
    {
      label: 'Text Align',
      controlId: 'text-align',
      name: 'text-align',
      inputType: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
      stateKey: 'text-align',
    },
    {
      label: 'Font Style',
      controlId: 'font-style',
      name: 'font-style',
      inputType: 'select',
      options: [
        { value: 'normal', label: 'Normal' },
        { value: 'italic', label: 'Italic' },
        { value: 'oblique', label: 'Oblique' },
      ],
      stateKey: 'font-style',
    },
    {
      label: 'Text Transform',
      controlId: 'text-transform',
      name: 'text-transform',
      inputType: 'select',
      options: [
        { value: 'capitalize', label: 'Capitalize' },
        { value: 'uppercase', label: 'Uppercase' },
        { value: 'lowercase', label: 'Lowercase' },
        { value: 'none', label: 'None' },
      ],
      stateKey: 'text-transform',
    },
    {
      label: 'Font Weight',
      controlId: 'font-weight',
      name: 'font-weight',
      inputType: 'select',
      options: [
        { value: '400', label: 'Normal' },
        { value: 'bold', label: 'Bold' },
      ],
      stateKey: 'font-weight',
    },
    {
      label: 'Text Decoration',
      controlId: 'text-decoration',
      name: 'text-decoration',
      inputType: 'select',
      options: [
        { value: 'none', label: 'None' },
        { value: 'underline', label: 'Underline' },
        { value: 'line-through', label: 'Line Through' },
        { value: 'overline', label: 'Overline' },
      ],
      stateKey: 'text-decoration',
    },
    {
      label: 'Color',
      controlId: 'color',
      name: 'color',
      inputType: 'color',
      stateKey: 'color',
    },
    {
      label: 'Font Size (px)',
      controlId: 'font-size',
      name: 'font-size',
      inputType: 'number',
      stateKey: 'font-size',
    },
    {
      label: 'Padding Top',
      controlId: 'padding-top',
      name: 'padding-top',
      inputType: 'number',
      stateKey: 'padding-top',
    },
    {
      label: 'Padding Left',
      controlId: 'padding-left',
      name: 'padding-left',
      inputType: 'number',
      stateKey: 'padding-left',
    },
    {
      label: 'Padding Right',
      controlId: 'padding-right',
      name: 'padding-right',
      inputType: 'number',
      stateKey: 'padding-right',
    },
    {
      label: 'Padding Bottom',
      controlId: 'padding-bottom',
      name: 'padding-bottom',
      inputType: 'number',
      stateKey: 'padding-bottom',
    },
    {
      label: 'Margin Top',
      controlId: 'margin-top',
      name: 'margin-top',
      inputType: 'number',
      stateKey: 'margin-top',
    },
    {
      label: 'Margin Left',
      controlId: 'margin-left',
      name: 'margin-left',
      inputType: 'number',
      stateKey: 'margin-left',
    },
    {
      label: 'Margin Right',
      controlId: 'margin-right',
      name: 'margin-right',
      inputType: 'number',
      stateKey: 'margin-right',
    },
    {
      label: 'Margin Bottom',
      controlId: 'margin-bottom',
      name: 'margin-bottom',
      inputType: 'number',
      stateKey: 'margin-bottom',
    },
  ],
  topCallToActionFields: [
    {
      label: 'Text',
      controlId: 'content',
      name: 'content',
      inputType: 'text',
      stateKey: 'content',
    },
    {
      label: 'Background Color',
      controlId: 'background-color',
      name: 'background-color',
      inputType: 'color',
      stateKey: 'background-color',
    },
    {
      label: 'Text Align',
      controlId: 'text-align',
      name: 'text-align',
      inputType: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
      stateKey: 'text-align',
    },
    {
      label: 'Font Style',
      controlId: 'font-style',
      name: 'font-style',
      inputType: 'select',
      options: [
        { value: 'normal', label: 'Normal' },
        { value: 'italic', label: 'Italic' },
        { value: 'oblique', label: 'Oblique' },
      ],
      stateKey: 'font-style',
    },
    {
      label: 'Text Transform',
      controlId: 'text-transform',
      name: 'text-transform',
      inputType: 'select',
      options: [
        { value: 'capitalize', label: 'Capitalize' },
        { value: 'uppercase', label: 'Uppercase' },
        { value: 'lowercase', label: 'Lowercase' },
        { value: 'none', label: 'None' },
      ],
      stateKey: 'text-transform',
    },
    {
      label: 'Font Weight',
      controlId: 'font-weight',
      name: 'font-weight',
      inputType: 'select',
      options: [
        { value: '400', label: 'Normal' },
        { value: 'bold', label: 'Bold' },
      ],
      stateKey: 'font-weight',
    },
    {
      label: 'Text Decoration',
      controlId: 'text-decoration',
      name: 'text-decoration',
      inputType: 'select',
      options: [
        { value: 'none', label: 'None' },
        { value: 'underline', label: 'Underline' },
        { value: 'line-through', label: 'Line Through' },
        { value: 'overline', label: 'Overline' },
      ],
      stateKey: 'text-decoration',
    },
    {
      label: 'Color',
      controlId: 'color',
      name: 'color',
      inputType: 'color',
      stateKey: 'color',
    },
    {
      label: 'Font Size (px)',
      controlId: 'font-size',
      name: 'font-size',
      inputType: 'number',
      stateKey: 'font-size',
    },
    {
      label: 'Padding Top',
      controlId: 'padding-top',
      name: 'padding-top',
      inputType: 'number',
      stateKey: 'padding-top',
    },
    {
      label: 'Padding Left',
      controlId: 'padding-left',
      name: 'padding-left',
      inputType: 'number',
      stateKey: 'padding-left',
    },
    {
      label: 'Padding Right',
      controlId: 'padding-right',
      name: 'padding-right',
      inputType: 'number',
      stateKey: 'padding-right',
    },
    {
      label: 'Padding Bottom',
      controlId: 'padding-bottom',
      name: 'padding-bottom',
      inputType: 'number',
      stateKey: 'padding-bottom',
    },
    {
      label: 'Margin Top',
      controlId: 'margin-top',
      name: 'margin-top',
      inputType: 'number',
      stateKey: 'margin-top',
    },
    {
      label: 'Margin Left',
      controlId: 'margin-left',
      name: 'margin-left',
      inputType: 'number',
      stateKey: 'margin-left',
    },
    {
      label: 'Margin Right',
      controlId: 'margin-right',
      name: 'margin-right',
      inputType: 'number',
      stateKey: 'margin-right',
    },
    {
      label: 'Margin Bottom',
      controlId: 'margin-bottom',
      name: 'margin-bottom',
      inputType: 'number',
      stateKey: 'margin-bottom',
    },
  ],
  bottomCallToActionFields: [
    {
      label: 'Text',
      controlId: 'content',
      name: 'content',
      inputType: 'text',
      stateKey: 'content',
    },
    {
      label: 'Background Color',
      controlId: 'background-color',
      name: 'background-color',
      inputType: 'color',
      stateKey: 'background-color',
    },
    {
      label: 'Text Align',
      controlId: 'text-align',
      name: 'text-align',
      inputType: 'select',
      options: [
        { value: 'left', label: 'Left' },
        { value: 'center', label: 'Center' },
        { value: 'right', label: 'Right' },
      ],
      stateKey: 'text-align',
    },
    {
      label: 'Font Style',
      controlId: 'font-style',
      name: 'font-style',
      inputType: 'select',
      options: [
        { value: 'normal', label: 'Normal' },
        { value: 'italic', label: 'Italic' },
        { value: 'oblique', label: 'Oblique' },
      ],
      stateKey: 'font-style',
    },
    {
      label: 'Text Transform',
      controlId: 'text-transform',
      name: 'text-transform',
      inputType: 'select',
      options: [
        { value: 'capitalize', label: 'Capitalize' },
        { value: 'uppercase', label: 'Uppercase' },
        { value: 'lowercase', label: 'Lowercase' },
        { value: 'none', label: 'None' },
      ],
      stateKey: 'text-transform',
    },
    {
      label: 'Font Weight',
      controlId: 'font-weight',
      name: 'font-weight',
      inputType: 'select',
      options: [
        { value: '400', label: 'Normal' },
        { value: 'bold', label: 'Bold' },
      ],
      stateKey: 'font-weight',
    },
    {
      label: 'Text Decoration',
      controlId: 'text-decoration',
      name: 'text-decoration',
      inputType: 'select',
      options: [
        { value: 'none', label: 'None' },
        { value: 'underline', label: 'Underline' },
        { value: 'line-through', label: 'Line Through' },
        { value: 'overline', label: 'Overline' },
      ],
      stateKey: 'text-decoration',
    },
    {
      label: 'Color',
      controlId: 'color',
      name: 'color',
      inputType: 'color',
      stateKey: 'color',
    },
    {
      label: 'Font Size (px)',
      controlId: 'font-size',
      name: 'font-size',
      inputType: 'number',
      stateKey: 'font-size',
    },
    {
      label: 'Padding Top',
      controlId: 'padding-top',
      name: 'padding-top',
      inputType: 'number',
      stateKey: 'padding-top',
    },
    {
      label: 'Padding Left',
      controlId: 'padding-left',
      name: 'padding-left',
      inputType: 'number',
      stateKey: 'padding-left',
    },
    {
      label: 'Padding Right',
      controlId: 'padding-right',
      name: 'padding-right',
      inputType: 'number',
      stateKey: 'padding-right',
    },
    {
      label: 'Padding Bottom',
      controlId: 'padding-bottom',
      name: 'padding-bottom',
      inputType: 'number',
      stateKey: 'padding-bottom',
    },
    {
      label: 'Margin Top',
      controlId: 'margin-top',
      name: 'margin-top',
      inputType: 'number',
      stateKey: 'margin-top',
    },
    {
      label: 'Margin Left',
      controlId: 'margin-left',
      name: 'margin-left',
      inputType: 'number',
      stateKey: 'margin-left',
    },
    {
      label: 'Margin Right',
      controlId: 'margin-right',
      name: 'margin-right',
      inputType: 'number',
      stateKey: 'margin-right',
    },
    {
      label: 'Margin Bottom',
      controlId: 'margin-bottom',
      name: 'margin-bottom',
      inputType: 'number',
      stateKey: 'margin-bottom',
    },
  ],
  generalStylesFields: [
    {
      label: 'Font Family',
      controlId: 'font-family',
      name: 'font-family',
      inputType: 'text',
      stateKey: 'font-family',
    },
  ],
};

export default templateWizardFormFields;
